import React, { Component } from 'react'
import { getBoardsData, getBranchesLatest } from '../../../store/actions';
import Service from '../../services';
import Authentication from '../../session';
import withRouter from '../../lib/withRouter';
import { connect } from 'react-redux';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import { AddIcon2, BrowseIcon, CalenderCheckIcon, ClockIcon, MailIcon } from '../../svgIcons';
import { getFormFields, isFormValid, onChoiceChange, onDropDownChange, onTextChange } from '../../../utile/formHelper';
import ClassetInputText from '../../../classetComponents/classetInputText';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../../loadingComponent';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { SelectButton } from 'primereact/selectbutton';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import moment from 'moment';
import ClassetCalendar from '../../../classetComponents/classetCalender';
import { paymentModes, StaticConstants } from '../../../constants';
import { Dialog } from 'primereact/dialog';
// import NTTPaymentComponent from '../../NTTPaymentComponent/NTTPaymentComponent';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import { convertUtc, trimObj } from '../../../utile';
import FeeReciept from '../receipt'
import FileUpload from '../../discussionBoard/common/fileUpload';
import Axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import asymmetricEncryptionUtils from '../../../utils/asymmetricEncryptionUtils';
import NTTPaymentComponent from '../../financeManagement/NTTPaymentComponent';
import { PERMISSIONS } from '../../session/authorizer';



const createExamFields = require('./examCreate.json');
const createFields = require('./collectFee.json');
const formFields = createExamFields;
const awsRegion = process.env.REACT_APP_AWS_REGION || 'ap-south-1';
const profilesBucket = process.env.REACT_APP_PROFILES_BUCKET || 'classet-profiles-old';

// import Axios from 'axios';
// import { v4 as uuidv4 } from 'uuid';


let selectedExamType = [
    {
        "label": "Offline",
        "value": "offline",
        "isActive": true,
        "isSelected": false
    },
    // {
    //     "label": "Online",
    //     "value": "online",
    //     "isActive": true,
    //     "isSelected": false
    // }
]

class ExamCreate extends Component {
    constructor(props) {
        super(props);
        this.formFields = getFormFields(createExamFields);
        this.payformFields = getFormFields(createFields);
        this.state = {
            isLoading: false,
            exam: this.props.editExam?._id ? this.props.editExam : this.formFields.data,
            formValidations: this.formFields.formValidations,
            payFeeFormData: this.payformFields.data,
            payFee: this.payformFields.data,
            payFormValidations: this.payformFields.formValidations,
            allotExam: "",
            selectPaper: "",
            isExamFeePaid: false,
            isEdit: this.props?.editExam?._id ? true : false,
            date: null,
            isShowReceipt: false,
            receiptInfo: {},
            isShowPayFeeButton: false,
            isOpenPayFeeDailog: false,
            feePayInfo: {},
            paymentModes: [],
            transctionId: null,
            showNTTPayment: false,
            nttPaymentData: null

        }
        this.service = new Service();
    }

    // Check if exam fee is paid and show payment dialog if not
    checkApplicationFeePaidStatus = async () => {
        try {
            // First check if exam fee is configured by calling handlePayFee
            // This will set isShowPayFeeButton based on whether fee exists
            await this.handlePayFee();

            // Use setTimeout to ensure state has been updated before checking
            setTimeout(async () => {
                // If no fee is configured, don't show the dialog
                if (!this.state.isShowPayFeeButton) {
                    console.log("No exam/test fee configured. Skipping fee dialog.");
                    return;
                }

                console.log("Exam fee is configured. Checking payment status...");

                // First check if we have an exam ID
                if (this.props?.editExam?._id || this.state.exam?._id) {
                    const examId = this.props?.editExam?._id || this.state.exam?._id;

                    // Check fee payment status for existing exam
                    const url = `${baseUrlAdmin}/admissions/feePaidInfo?_id=${examId}`;
                    const res = await this.service.get(url, true);

                    if (res && res.status && res.res.status) {
                        const receiptInfo = res.res.data;
                        const isFeePaid = receiptInfo?.isExamFeePaid || false;

                        this.setState({
                            isExamFeePaid: isFeePaid,
                            receiptInfo: receiptInfo
                        });

                        // If fee is not paid, show payment dialog
                        if (!isFeePaid) {
                            console.log("Fee not paid. Opening payment dialog...");
                            this.openDailogPayAppFee();
                        } else {
                            console.log("Fee already paid. Skipping dialog.");
                        }
                    } else {
                        // Fee not paid, show dialog
                        console.log("Could not get fee status. Opening payment dialog...");
                        this.setState({ isExamFeePaid: false });
                        this.openDailogPayAppFee();
                    }
                } else {
                    // For new exams, show dialog as fee is required
                    console.log("New exam. Opening payment dialog...");
                    this.setState({ isExamFeePaid: false });
                    this.openDailogPayAppFee();
                }
            }, 300); // Wait 300ms for state to update
        } catch (error) {
            console.error('Error checking exam fee status:', error);
            this.setState({ isExamFeePaid: false });
        }
    };

    async componentDidMount() {

        // Check for payment status in URL (after redirect from payment gateway)
        const urlParams = new URLSearchParams(window.location.search);
        const paymentStatus = urlParams.get('status');
        const txnId = urlParams.get('txnId');
        const atomTxnId = urlParams.get('atomTxnId');
        const referenceNo = urlParams.get('referenceNo');

        // Handle payment redirect
        if (paymentStatus) {
            this.handlePaymentRedirect(paymentStatus, txnId, atomTxnId, referenceNo);
        }

        //Check if exam fee is paid and show payment dialog if not paid
        await this.checkApplicationFeePaidStatus();

        if (this.props.editExam?._id) {
            this.setState((prevState) => ({
                exam: { ...prevState.exam, ...prevState.exam?.exam },
                date: prevState.exam?.exam?.date,
                time: prevState.exam?.exam?.time,
                examType: prevState.exam?.exam?.examType,
                allotExam: prevState.exam?.exam?.allotExam,
                selectPaper: prevState.exam?.exam?.selectPaper,
                score: prevState.exam?.exam?.score,
                remarks: prevState.exam?.exam?.remarks,
            }), async () => {
                await this.handlePayFee(false)
            })
        }
        const applicationId = await localStorage.getItem('applicationId')
        this.props.getBranchesLatest()
        this.props.getBoardsData(true);
        await this.getAdmissionTypeDropdown()
        await this.getAcademicSessions()
        if (applicationId) {
            await this.getAdmissionInfo(applicationId)
        }
        await this.getAdmissionSettingsInfo()
    }


    handlePayFee = async () => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/application-fee/filter`;
        try {
            let payload = {
                "isActive": true,
                "academicYear": this.state.exam?.academicSession,
                "orgId": this.state.exam?.orgId,
                "board": this.state.exam?.board,
                "grade": this.state.exam?.grade,
                "admissionStep": "Exam"
            }
            const res = await this.service.post(url, payload, true);
            if (res?.res?.status && res.status) {
                this.setState({
                    feePayInfo: res?.res?.data,
                    isShowPayFeeButton: (res?.res?.data && Object.keys(res?.res?.data).length) ? true : false,
                    isLoading: false
                });
            } else {
                this.setState({
                    isLoading: false
                });
                if (this.toast) {
                    this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
                }
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            if (this.toast) {
                this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
            }
        }

    };

    getAdmissionInfo = async (applicationId) => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/admissions/form?id=${applicationId}`;
        this.service.get(url, true).then(res => {
            if (res && res.status && res.res.status) {
                if (res.res.data && res.res.data.admissionRecords.length) {
                    // Handle nested array structure: admissionRecords[0][0] or admissionRecords[0]
                    let admissionRecord = res.res.data.admissionRecords[0];

                    // Check if it's a nested array and extract the actual record
                    if (Array.isArray(admissionRecord) && admissionRecord.length > 0) {
                        admissionRecord = admissionRecord[0];
                        console.log('📦 getAdmissionInfo (exam): Extracted from nested array structure');
                    }

                    this.setState({
                        isLoading: false,
                        exam: admissionRecord,
                    }, async () => {
                        await this.handlePayFee(false)
                        await this.checkApplicationFeePaidStatus();
                        localStorage.removeItem('applicationId')
                    });
                }
            } else {
                this.setState({
                    isLoading: true
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
            console.log(e);
        })
    }


    getAcademicSessions = async () => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/academic-years/filter`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const result = res?.res?.data?.map(admision => ({
                    label: admision.academicCode,
                    value: admision._id
                }));
                this.setState({ academicSession: result, isLoading: false });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }

    };


    getAdmissionTypeDropdown = async () => {
        this.setState({
            isLoading: true
        });
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admission-types/active?academicYear=${academicYear}`
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const result = res?.res?.data?.map(admision => ({
                    label: admision.categoryName,
                    value: admision._id
                }));

                this.setState({ academicCategory: result, isLoading: false });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
            }
        } catch (e) {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }

    };

    openDailogPayAppFee = () => {
        let paymentMode = paymentModes.filter((e) => e.value !== '1c98862e-46dc-4454-a120-7d15e2e56e2f' && e.value !== '9d08ebab-2d3e-4a30-8460-4e4092fe30a1');
        this.setState({ isOpenPayFeeDailog: true, paymentModes: paymentMode });
    }

    onHandleCancelPayFee = () => {
        this.setState({
            isOpenPayFeeDailog: false,
            payFeeFormData: {}
        })
    }
    _afterFilesUploaded = (files) => {

    }
    addAttachment = (fieldName, fileName, data) => {
        let allotExam = {
            [fieldName]: {
                fileName,
                storageBucket: data.Bucket,
                storageKey: data.Key,
                storageLocation: data.Location,
            }

        }
        this.setState((prevState) => {
            return { allotExam, uploadedFileName: fileName }
        });
    }

    _onUploadPdf = (fileName, data) => {
        this.addAttachment('allotExam', fileName, data);
    }

    _onFilsUploadError = (errMsg) => {
        this.toast.show({ severity: 'error', summary: 'Some error', detail: errMsg, life: 3000 });
    }

    getAdmissionSettingsInfo = async () => {
        this.setState({
            isLoading: true
        });
        let academicYear = localStorage.getItem('userAcademicYear')
        let url = `${baseUrlAdmin}/admissions/process?academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                this.setState({ admissionSettingsInfo: res?.res?.data, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    }

    // ////////////PG SDK or Script loading////////
    loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    // loadCashfreeSDK = () => {
    // }

    /**
     * Handle NTT Data payment initiation for exam
     */
    handleNTTDataPayment = () => {
        const { payFeeFormData, exam, feePayInfo } = this.state;

        // Save complete exam state before payment redirect
        const examStateToSave = {
            exam: exam,
            feePayInfo: feePayInfo,
            timestamp: Date.now()
        };

        sessionStorage.setItem('pendingExamPayment', JSON.stringify(examStateToSave));
        sessionStorage.setItem('examAdmissionId', exam?._id);
        sessionStorage.setItem('examReferenceNo', exam?.referenceNo);

        const paymentData = {
            amount: this.state.partialPayment
                ? payFeeFormData?.amountPaying
                : (feePayInfo?.amount || payFeeFormData?.dueAmount),
            studentId: exam?._id,
            installmentId: payFeeFormData?.installmentId,
            feeFor: 'Admissions',
            feeType: 'Exam',
            studentName: exam?.firstName && exam?.lastName
                ? `${exam.firstName} ${exam.lastName}`.trim()
                : exam?.firstName || 'Student',
            studentEmail: exam?.emailId || exam?.parentEmailId || 'student@classet.com',
            studentPhone: exam?.parentContact || exam?.contactNo || '9999999999',
            branchId: exam?.branch,
            boardId: exam?.board,
            classId: exam?.grade,
            sectionId: exam?.section,
            orgId: localStorage.getItem('orgId'),
            referenceNo: exam?.referenceNo

        };

        console.log('Initiating NTT Data payment for exam with data:', paymentData);

        this.setState({
            showNTTPayment: true,
            nttPaymentData: paymentData
        });
    };

    /**
     * Handle successful NTT payment for exam
     */
    onNTTPaymentSuccess = (paymentResult) => {
        console.log('NTT Payment successful for exam:', paymentResult);

        this.setState({
            transctionId: paymentResult.transactionId || paymentResult.payment_id,
            showNTTPayment: false,
            nttPaymentData: null
        }, () => {
            this.OnPayFee();
        });
    };

    /**
     * Handle NTT payment error for exam
     */
    onNTTPaymentError = (error) => {
        console.error('NTT Payment error for exam:', error);

        this.setState({
            showNTTPayment: false,
            nttPaymentData: null
        });

        if (this.toast) {
            this.toast.show({
                severity: 'error',
                summary: 'Payment Error',
                detail: error.message || 'Payment failed. Please try again.',
                life: 5000
            });
        }
    };

    /**
     * Handle NTT payment cancellation for exam
     */
    onNTTPaymentCancel = () => {
        console.log('NTT Payment cancelled for exam');

        this.setState({
            showNTTPayment: false,
            nttPaymentData: null
        });

        if (this.toast) {
            this.toast.show({
                severity: 'warn',
                summary: 'Payment Cancelled',
                detail: 'Payment was cancelled by user',
                life: 3000
            });
        }
    };

    /**
     * Handle payment redirect after gateway returns (for Exam)
     */
    handlePaymentRedirect = async (status, txnId, atomTxnId, referenceNo) => {
        console.log('Exam payment redirect detected:', { status, txnId, atomTxnId, referenceNo });

        // Restore exam state from sessionStorage
        const savedState = sessionStorage.getItem('pendingExamPayment');

        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState);
                const savedAdmissionId = sessionStorage.getItem('examAdmissionId');
                const savedReferenceNo = sessionStorage.getItem('examReferenceNo');

                // Check if saved state is not too old (30 minutes)
                if (Date.now() - parsedState.timestamp < 30 * 60 * 1000) {

                    if (status === 'success') {
                        // Payment successful
                        this.setState({
                            isLoading: true
                        });

                        // Verify payment status from backend
                        try {
                            const verifyUrl = `${baseUrlAdmin}/admissions/verify-admission-payment`;
                            const verifyResponse = await this.service.post(verifyUrl, {
                                txnId: txnId, // merchTxnId (order_id) - guaranteed to exist
                                atomTxnId: atomTxnId, // May not exist yet if callback hasn't arrived
                                admissionId: savedAdmissionId,
                                referenceNo: savedReferenceNo || referenceNo
                            }, true);

                            if (verifyResponse?.res?.status) {
                                // Payment verified successfully
                                const paymentData = verifyResponse.res.data;

                                // Restore exam state
                                this.setState({
                                    exam: {
                                        ...parsedState.exam,
                                        examFeePaid: true
                                    },
                                    isExamFeePaid: true,
                                    isLoading: false,
                                    receiptInfo: paymentData.receipt || null,
                                    isPaymentJustCompleted: true
                                }, () => {
                                    // Format and show receipt using handleShowReceipt
                                    if (paymentData.receipt) {
                                        this.handleShowReceipt(true);
                                    }
                                });

                                // Show success message with confirmation
                                this.toast.show({
                                    severity: 'success',
                                    summary: '✅ Payment Successful',
                                    detail: `Exam fee paid successfully! Transaction ID: ${txnId}`,
                                    life: 8000,
                                    sticky: false
                                });

                                // Clear session storage
                                sessionStorage.removeItem('pendingExamPayment');
                                sessionStorage.removeItem('examAdmissionId');
                                sessionStorage.removeItem('examReferenceNo');

                                // Clean URL
                                window.history.replaceState({}, document.title, '/addExam');
                            } else {
                                throw new Error(verifyResponse?.res?.message || 'Payment verification failed');
                            }
                        } catch (error) {
                            console.error('Payment verification error:', error);

                            // Restore form silently - verification may fail temporarily while callback is processing
                            this.setState({
                                exam: parsedState.exam,
                                isLoading: false
                            });

                            // Clear session storage and URL
                            sessionStorage.removeItem('pendingExamPayment');
                            sessionStorage.removeItem('examAdmissionId');
                            sessionStorage.removeItem('examReferenceNo');
                            window.history.replaceState({}, document.title, '/addExam');
                        }
                    } else if (status === 'failure') {
                        // Payment failed
                        this.setState({
                            exam: parsedState.exam,
                            isLoading: false
                        });

                        this.toast.show({
                            severity: 'error',
                            summary: '❌ Payment Failed',
                            detail: 'Payment was not completed. Please try again.',
                            life: 5000
                        });

                        // Clean URL
                        window.history.replaceState({}, document.title, '/addExam');
                    } else if (status === 'cancelled') {
                        // Payment cancelled
                        this.setState({
                            exam: parsedState.exam,
                            isLoading: false
                        });

                        this.toast.show({
                            severity: 'warn',
                            summary: 'Payment Cancelled',
                            detail: 'You cancelled the payment. You can retry payment anytime.',
                            life: 5000
                        });

                        // Clean URL
                        window.history.replaceState({}, document.title, '/addExam');
                    }
                } else {
                    // Session expired
                    this.toast.show({
                        severity: 'warn',
                        summary: 'Session Expired',
                        detail: 'Payment session expired. Please start again.',
                        life: 5000
                    });
                    sessionStorage.removeItem('pendingExamPayment');
                    sessionStorage.removeItem('examAdmissionId');
                    sessionStorage.removeItem('examReferenceNo');
                }
            } catch (error) {
                console.error('Error restoring exam state:', error);
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to restore exam data',
                    life: 5000
                });
            }
        } else {
            // No saved state - might be a direct link or manual refresh
            if (status === 'success' && referenceNo) {
                this.toast.show({
                    severity: 'info',
                    summary: 'Payment Completed',
                    detail: 'Loading your exam details...',
                    life: 3000
                });

                // Try to verify payment and load exam by referenceNo
                try {
                    const verifyUrl = `${baseUrlAdmin}/admissions/verify-admission-payment`;
                    const verifyResponse = await this.service.post(verifyUrl, {
                        txnId: txnId, // merchTxnId (order_id)
                        atomTxnId: atomTxnId, // atom_order_id
                        referenceNo: referenceNo
                    }, true);

                    if (verifyResponse?.res?.status && verifyResponse.res.data?.referenceNo) {
                        // Load admission by referenceNo
                        const admissionId = sessionStorage.getItem('examAdmissionId') || localStorage.getItem('applicationId');
                        if (admissionId) {
                            await this.getAdmissionInfo(admissionId);

                            this.toast.show({
                                severity: 'success',
                                summary: '✅ Payment Confirmed',
                                detail: `Payment successful! Transaction ID: ${verifyResponse.res.data.transactionId}`,
                                life: 5000
                            });

                            // Clean URL
                            window.history.replaceState({}, document.title, '/addExam');
                        }
                    }
                } catch (error) {
                    console.error('Error loading exam after payment:', error);
                    this.toast.show({
                        severity: 'warn',
                        summary: 'Payment Completed',
                        detail: 'Payment was successful but could not load exam. Please refresh the page.',
                        life: 5000
                    });
                }
            }
        }
    };


    handlePayment = async () => {
        let payType = this.state.payFeeFormData?.paymentType;
        let a = this.state.partialPayment ? this.state.payFeeFormData?.amountPaying : this.state.payFeeFormData?.dueAmount
        // let PGtype = 'cashfree'; // Default payment gateway type, can be changed based on user selection
        let PGtype = process.env.REACT_APP_DEFAULT_PAYMENT_GATEWAY || 'ntt_data';


        if (payType) {

            if (
                payType === '74b95cc8-9736-44a0-b2df-325595783c3b' ||
                payType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' ||
                payType === "9d08ebab-2d3e-4a30-8460-4e4092fe30a1" ||
                payType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                payType === "274a4416-2454-4f3a-b741-89c67361ae1f"
            ) {
                this.OnPayFee()
            } else if (
                payType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' ||
                payType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
            ) {
                switch (PGtype) {
                    case 'ntt_data': {
                        console.log('🔄 Initiating NTT Data payment for exam...');
                        this.handleNTTDataPayment();
                        break;
                    }
                    case 'razorpay': {
                        const res = await this.loadRazorpayScript();
                        if (!res) {
                            alert("Failed to load Razorpay SDK. Check your internet connection.");
                            return;
                        }
                        let url = `${baseUrlAdmin}/create-order`;
                        let vurl = `${baseUrlAdmin}/verify-payment`;

                        let payload = {
                            amount: this.state.partialPayment ? this.state.payFeeFormData?.amountPaying * 100 : this.state.payFeeFormData?.dueAmount * 100,
                            currency: "INR"
                        }
                        // Get order details from your backend
                        const { data: order } = await Axios.post(url, payload);

                        const options = {
                            key: "rzp_test_rJgczs9D0fmDjk", // Replace with your Razorpay key
                            amount: order.amount,
                            currency: order.currency,
                            name: "Classet",
                            description: "Purchase Description",
                            image: `https://${profilesBucket}.s3.${awsRegion}.amazonaws.com/uploads/17358829538761712311939159IMG-20231127-WA0017%20-%20Copy.jpg`,
                            order_id: order.id,
                            handler: async (response) => {
                                const result = await Axios.post(vurl, {
                                    order_id: order.id,
                                    razorpay_payment_id: response.razorpay_payment_id,
                                    razorpay_signature: response.razorpay_signature,
                                });
                                this.setState({
                                    transctionId: response.razorpay_payment_id
                                }, () => {
                                    this.OnPayFee();
                                })
                            },

                            prefill: {
                                name: "Monangi Kiran",
                                email: "kiranm@classet.in",
                                contact: "7799279701",
                            },
                            theme: {
                                color: "#3399cc",
                            },
                        };

                        const paymentObject = new window.Razorpay(options);
                        console.log("RAZOR", paymentObject)
                        paymentObject.open();
                    }; break;
                    case 'cashfree': {
                        let parentContactNumer;
                        if (this.state.searchLevel === 2) {
                            parentContactNumer = this.state?.dropdownsData?.parentContactNumber[0];
                        }

                        const url = `${baseUrlAdmin}/cashfree/create-order`;
                        const payload = {
                            orgId: localStorage.getItem('orgId'),
                            academicYear: localStorage.getItem('userAcademicYear'),
                            platform: 'web',

                            order_amount: this.state.partialPayment
                                ? this.state.payFeeFormData?.amountPaying
                                : this.state.feePayInfo?.amount || 102,
                            order_currency: "INR",
                            order_id: "order_" + uuidv4(), // Generate a unique order ID using uuid
                            customer_details: {
                                customer_name: this.state?.exam?.firstName && this.state?.exam?.lastName
                                    ? `${this.state.exam.firstName} ${this.state.exam.lastName}`.trim()
                                    : `${this.state?.exam?.firstName}`,
                                customer_id: this.state?.exam?._id,
                                // customer_email: this.state?.exam?.emailId || "NA1234@gmail.com",
                                // customer_phone: this.state?.exam?.parentContact || this.state?.exam?.contactNo || "4044044044",
                                // // ...existing code...
                                customer_email: this.state?.exam?.parentEmailId,
                                customer_phone: this.state?.exam?.parentContact || this.state?.exam?.contactNo,
                                // ...existing code...
                            },
                            order_meta: {
                                return_url: null,
                            },
                        };

                        this.setState({ isLoading: true });

                        // Try asymmetric encryption first, fallback to symmetric, then unencrypted
                        const encryptPayload = async (payload) => {
                            try {
                                // Use only asymmetric (hybrid) encryption for strong security
                                console.log('🔐 Attempting hybrid encryption for Cashfree order creation...');
                                const hybridEncrypted = await asymmetricEncryptionUtils.prepareEncryptedPayload(payload);

                                if (hybridEncrypted.hybridEncrypted) {
                                    console.log('✅ Hybrid encryption successful for order creation');
                                    return hybridEncrypted;
                                }

                                // If encryption fails, throw error instead of sending unencrypted data
                                throw new Error('Hybrid encryption failed');

                            } catch (error) {
                                console.error('❌ Payment encryption failed:', error);
                                throw new Error('Payment encryption failed. Please try again.');
                            }
                        };

                        encryptPayload(payload)
                            .then((encryptedPayload) => {
                                return this.service.post(url, encryptedPayload, true);
                            })
                            .then(async (response) => {
                                this.setState({ isLoading: false });

                                console.log('🔍 Raw Cashfree order creation response:', response);

                                // Decrypt the response if it's encrypted
                                let decryptedResponse = response;

                                // Check if response needs decryption
                                if (response?.res?.encrypted || response?.res?.hybridEncrypted) {
                                    try {
                                        console.log('🔓 Decrypting Cashfree order creation response...');
                                        console.log('🔍 Response structure before decryption:', {
                                            hasRes: !!response.res,
                                            encrypted: response.res?.encrypted,
                                            hybridEncrypted: response.res?.hybridEncrypted,
                                            keys: Object.keys(response.res || {})
                                        });

                                        // Decrypt using asymmetric encryption utils
                                        const decryptedData = await asymmetricEncryptionUtils.decryptResponse(response.res);

                                        console.log('✅ Order creation response decrypted successfully');
                                        console.log('🔍 Decrypted data structure:', {
                                            hasStatus: !!decryptedData.status,
                                            hasData: !!decryptedData.data,
                                            dataKeys: Object.keys(decryptedData.data || {}),
                                            hasPaymentSessionId: !!decryptedData.data?.payment_session_id
                                        });

                                        decryptedResponse = {
                                            ...response,
                                            res: decryptedData
                                        };

                                        // Also create direct data access for backward compatibility
                                        decryptedResponse.data = decryptedData.data;
                                        decryptedResponse.status = decryptedData.status;

                                    } catch (decryptError) {
                                        console.error('❌ Error decrypting order creation response:', decryptError);
                                        console.warn('⚠️ Using original response due to decryption error');
                                        // Continue with original response as fallback
                                    }
                                } else {
                                    console.log('✅ Response is not encrypted, using as-is');
                                    // For unencrypted responses, ensure proper structure
                                    if (response.res) {
                                        decryptedResponse.data = response.res.data;
                                        decryptedResponse.status = response.res.status;
                                    }
                                }

                                console.log('🔍 Final decryptedResponse structure:', {
                                    hasStatus: !!decryptedResponse.status,
                                    hasData: !!decryptedResponse.data,
                                    hasResStatus: !!decryptedResponse.res?.status,
                                    hasResData: !!decryptedResponse.res?.data,
                                    dataKeys: Object.keys(decryptedResponse.data || {}),
                                    resDataKeys: Object.keys(decryptedResponse.res?.data || {})
                                });

                                // Check for payment_session_id in correct response structure
                                let paymentSessionId = null;
                                let foundInLocation = '';

                                // Primary locations - check decrypted response first
                                if (decryptedResponse.data?.payment_session_id) {
                                    paymentSessionId = decryptedResponse.data.payment_session_id;
                                    foundInLocation = 'decryptedResponse.data.payment_session_id';
                                } else if (decryptedResponse.res?.data?.payment_session_id) {
                                    paymentSessionId = decryptedResponse.res.data.payment_session_id;
                                    foundInLocation = 'decryptedResponse.res.data.payment_session_id';
                                } else if (decryptedResponse.data?.paymentSessionId) {
                                    paymentSessionId = decryptedResponse.data.paymentSessionId;
                                    foundInLocation = 'decryptedResponse.data.paymentSessionId';
                                } else if (decryptedResponse.res?.data?.paymentSessionId) {
                                    paymentSessionId = decryptedResponse.res.data.paymentSessionId;
                                    foundInLocation = 'decryptedResponse.res.data.paymentSessionId';
                                }

                                console.log('🔍 Payment session ID search result:', {
                                    paymentSessionId,
                                    foundInLocation,
                                    responseHasStatus: !!decryptedResponse.status,
                                    responseResHasStatus: !!decryptedResponse.res?.status
                                });

                                if ((decryptedResponse.status || decryptedResponse.res?.status) && paymentSessionId) {
                                    console.log('✅ Order created successfully with payment session ID:', paymentSessionId);

                                    //TO CREATE ORDER -> from order, paymentSessionId generated -> payments gets completed.
                                    // Open Cashfree checkout modal
                                    const checkoutOptions = {
                                        paymentSessionId: paymentSessionId,
                                        redirectTarget: "_modal",
                                    };
                                    const initializeCashfree = async () => {
                                        const { load } = await import('@cashfreepayments/cashfree-js');
                                        // const cashfree = await load({ mode: "sandbox" }); // Use "production" for live environment
                                        const cashfreeMode = process.env.REACT_APP_CASHFREE_MODE;
                                        const cashfree = await load({ mode: cashfreeMode });

                                        cashfree.checkout(checkoutOptions).then((result) => {
                                            if (result.error) {
                                                console.error("Payment error:", result.error);
                                            } else if (result.paymentDetails) {
                                                console.log("===AFTER PAYMENT DETAILS===:", result);
                                                console.log("Payment completed successfully:", result.paymentDetails);

                                                // store the payment details.
                                                sendPaymentSessionDetails()
                                                console.log('PAYLOAD.ORDER_ID:', payload.order_id);
                                            }
                                        });
                                    };
                                    initializeCashfree();

                                    // Send and Store 
                                    const sendPaymentSessionDetails = async () => {
                                        const isDoneThrough = "Web-Admin"
                                        const loggedInUser = localStorage.getItem('username');

                                        try {
                                            // Prepare the verify-and-collect payload
                                            const verifyCollectPayload = {
                                                platform: 'web',

                                                // Order and payment details
                                                orderId: payload.order_id,
                                                paymentSessionId: paymentSessionId,
                                                paymentDetails: 'payment finished',

                                                // Organization and academic details
                                                academicYear: localStorage.getItem('userAcademicYear'),
                                                orgId: localStorage.getItem('orgId'),
                                                academicSession: localStorage.getItem('userAcademicYear'),
                                                academicYearCode: this.state.exam?.enquiry?.academicYearCode,
                                                admissionCategoryName: this.state.exam?.enquiry?.admissionCategoryName,

                                                // Student details
                                                studentName: `${this.state?.exam?.firstName} ${this.state?.exam?.lastName}`,
                                                applicationNo: this.state?.exam?.applicationId,
                                                admissionId: this.state?.exam?._id,
                                                gradeName: this.state.exam?.gradeName,

                                                // Fee details for Exam stage
                                                stage: 'Exam',
                                                paymentMode: this.state.paymentModes?.find((el) => el.value == this.state.payFeeFormData?.paymentType)?.label || 'Online Payment',
                                                paymentType: this.state.payFeeFormData?.paymentType || '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54',
                                                feeTypeName: this.state.feePayInfo?.feeName,
                                                FeeTypeName: this.state.feePayInfo?.feeName,
                                                feeAmount: Number(this.state.feePayInfo?.amount),

                                                // Additional required fields
                                                branchId: this.state?.exam?.branch,
                                                boardId: this.state?.exam?.board,
                                                classId: this.state?.exam?.grade,
                                                sectionId: this.state?.exam?.sectionId,
                                                studentId: this.state?.exam?._id,
                                                enrollmentNo: 'NA',
                                                parentContactNumber: this.state?.exam?.parentContact || this.state?.exam?.contactNo,

                                                // Metadata
                                                isDoneThrough: isDoneThrough,
                                                loggedInUser: loggedInUser,

                                                // Optional remarks
                                                remarks: this.state.payFeeFormData?.remarks || ''
                                            };

                                            // Encrypt verify-and-collect payload with asymmetric encryption only
                                            const encryptVerifyPayload = async (payload) => {
                                                try {
                                                    // Use only asymmetric (hybrid) encryption for strong security
                                                    console.log('🔐 Attempting hybrid encryption for payment verification...');
                                                    const hybridEncrypted = await asymmetricEncryptionUtils.prepareEncryptedPayload(payload);

                                                    if (hybridEncrypted.hybridEncrypted) {
                                                        console.log('✅ Hybrid encryption successful for verify-and-collect');
                                                        return hybridEncrypted;
                                                    }

                                                    // If encryption fails, throw error instead of sending unencrypted data
                                                    throw new Error('Hybrid encryption failed for verify-and-collect');

                                                } catch (error) {
                                                    console.error('❌ Payment verification encryption failed:', error);
                                                    throw new Error('Payment verification encryption failed. Please try again.');
                                                }
                                            };

                                            const encryptedVerifyPayload = await encryptVerifyPayload(verifyCollectPayload);
                                            const response = await this.service.post(`${baseUrlAdmin}/cashfree/verifyAndCollectAdmissionFee`, encryptedVerifyPayload, true);

                                            // Decrypt the response if it's encrypted (asymmetric only)
                                            let decryptedVerifyResponse = response;

                                            if (response?.res?.encrypted || response?.res?.hybridEncrypted) {
                                                try {
                                                    console.log('🔓 Decrypting verify-and-collect response with asymmetric encryption...');

                                                    // Use only asymmetric decryption for strong security
                                                    let decryptedData = await asymmetricEncryptionUtils.decryptResponse(response.res);

                                                    decryptedVerifyResponse = {
                                                        ...response,
                                                        res: decryptedData
                                                    };

                                                    console.log('✅ Verify-and-collect response decrypted successfully with RSA + AES');
                                                } catch (decryptError) {
                                                    console.error('❌ Error decrypting verify-and-collect response:', decryptError);
                                                    // Continue with original response as fallback
                                                    console.warn('⚠️ Using original response due to decryption error');
                                                }
                                            }

                                            if (decryptedVerifyResponse?.res?.res?.data) {
                                                // Payment successful - handle receipt generation
                                                console.log(decryptedVerifyResponse?.res)
                                                console.log("Transaction ID from response:", decryptedVerifyResponse?.res?.transactionId);
                                                console.log("Transaction ID from response:", decryptedVerifyResponse?.res?.res?.transactionId);

                                                const receiptData = decryptedVerifyResponse.res.res.data;
                                                const paymentDetails = decryptedVerifyResponse.res.res.paymentDetails;
                                                console.log("Receipt Data:", receiptData);

                                                // Attach transactionId from response?.res to receiptData
                                                if (decryptedVerifyResponse?.res?.res?.transactionId) {
                                                    receiptData.transactionId = decryptedVerifyResponse.res.transactionId || decryptedVerifyResponse?.res?.res?.transactionId;
                                                    receiptData.transctionId = decryptedVerifyResponse.res.transactionId || decryptedVerifyResponse?.res?.res?.transactionId; // Also set the misspelled version for compatibility
                                                }

                                                // Set transaction ID from Cashfree payment details or response
                                                const transactionId = decryptedVerifyResponse?.res?.res?.transactionId || paymentDetails?.cf_payment_id || 'N/A';

                                                // Set transaction ID from Cashfree payment details
                                                if (paymentDetails) {
                                                    this.setState({
                                                        transctionId: transactionId,
                                                    });
                                                }

                                                // Show success message
                                                this.toast.show({
                                                    severity: 'success',
                                                    summary: 'Payment Successful',
                                                    detail: 'Payment completed successfully. Receipt generated.',
                                                    life: 3000
                                                });

                                                // Set receipt data and show receipt dialog
                                                this.setState({
                                                    isEnableReceipt: true,
                                                    receiptData: receiptData,
                                                    openCreateFeeDialog: false,
                                                    isLoading: false,
                                                    isOpenPayFeeDailog: false, // Add this line to close the Pay Fee dialog

                                                    // Clear form data
                                                    payFeeFormData: {},
                                                    transactionDate: null,
                                                    chequeIssuedTo: '',
                                                    chequeNo: '',
                                                    chequeDate: new Date(),
                                                    bankName: '',
                                                    bankBranchName: '',
                                                    destinationBank: '',
                                                    transctionId: '',
                                                    approvalCode: '',
                                                    rrNumber: '',
                                                    userBankName: '',
                                                    cardNo: ''
                                                });

                                                //receipts
                                                this.onCheckFeePaidInfo(true);


                                                // // Optionally refresh receipts if on tab 2
                                                // if (this.state.tab === 2) {
                                                //     this.fetchReceipts();
                                                // }

                                            } else {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Error',
                                                    detail: decryptedVerifyResponse?.res?.errMessage || 'Failed to verify payment details - receipts',
                                                    life: 3000,
                                                });
                                            }
                                        } catch (error) {
                                            console.error("Error sending payment session details:", error);

                                            // Check if it's an encryption error
                                            if (error.message && error.message.includes('encrypt')) {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Encryption Error',
                                                    detail: 'Failed to encrypt payment verification data',
                                                    life: 3000,
                                                });
                                            } else {
                                                this.toast.show({
                                                    severity: 'error',
                                                    summary: 'Error',
                                                    detail: 'An error occurred sendingPaymentsSessionDetails',
                                                    life: 3000,
                                                });
                                            }
                                        }
                                    };



                                } else {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: decryptedResponse.errMessage || response.errMessage || 'Failed to create order (or) Cashfree subMerchantId not found for the organization',
                                        life: 3000,
                                    });
                                }
                            })
                            .catch((error) => {
                                this.setState({ isLoading: false });

                                // Check if it's an encryption error
                                if (error.message && error.message.includes('encrypt')) {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Encryption Error',
                                        detail: 'Failed to encrypt request data',
                                        life: 3000,
                                    });
                                    console.error("Encryption error:", error);
                                } else {
                                    this.toast.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: 'An error occurred while creating order',
                                        life: 3000,
                                    });
                                    console.error("Error in Cashfree order creation:", error);
                                }
                            });
                    }; break;
                }
            }
        } else {
            this.toast.show({ severity: 'error', summary: 'Please Check Validation', detail: 'Please Fill Payment Type And Amount', life: 3000 });

        }
    };


    OnPayFee = () => {
        const formStatus = isFormValid(createFields, this.payformFields.formValidations, trimObj(this.state.payFeeFormData));
        let isCompleteFormValid = true;
        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                payFormValidations: formStatus.formValidations,
            });
            isCompleteFormValid = false;
        }
        let academicYear = localStorage.getItem('userAcademicYear')
        let data = this.state.payFeeFormData
        this.setState({ isLoading: true })
        let url = `${baseUrlAdmin}/admissions/payFee`
        let paymentMode = this.state.paymentModes.find(el => el.value == data?.paymentType)?.label
        data.paymentMode = paymentMode
        data.FeeTypeName = this.state.feePayInfo?.feeName
        data.feeAmount = Number(this.state.feePayInfo?.amount)
        data.transctionId = this.state?.transctionId

        if (data?.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' || data?.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' || data?.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f' || data?.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489') {
            if (!data?.transctionId) {
                this.setState({
                    isLoading: false,
                });
                this.toast.show({ severity: 'error', summary: 'Please enter transaction id.', detail: "Please enter transaction id.", life: 3000 });
                return
            }
        } else {
            data.transctionId = null
        }
        let payload = { ...data }
        if (this.state?.exam?._id) {
            payload.academicYearCode = this.state.exam?.enquiry?.academicYearCode
            payload.admissionCategoryName = this.state.exam?.enquiry?.admissionCategoryName
            payload.studentName = `${this.state?.exam?.firstName} ${this.state?.exam?.lastName}`
            payload.applicationNo = this.state?.exam?.applicationId
            payload.admissionId = this.state?.exam?._id
            payload.academicYear = this.state?.exam?.academicSession
            payload.gradeName = this.state.exam?.gradeName
            // Only set stage to Exam if student is not already enrolled
            if (this.state.exam?.stage !== "Confirmed") {
                payload.stage = "Exam"
            }
        }
        if (isCompleteFormValid) {
            this.service.post(url, payload, true).then(res => {
                if (res && res.status && res.res.status) {
                    if (res.res.data) {
                        this.setState({
                            isOpenPayFeeDailog: false,
                            isLoading: false,
                            payFeeFormData: {},
                            transctionId: null,
                            isExamFeePaid: true,
                            receiptInfo: res.res.data
                        }, () => { this.onCheckFeePaidInfo(true) });
                        this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });
                    } else {
                        this.setState({
                            isLoading: false,
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res?.errMessage, life: 3000 });
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res?.errMessage, life: 3000 });
                }
            }).catch(e => {
                this.setState({
                    isLoading: false
                });
            })
        } else {
            this.setState({
                isLoading: false,
            });
            this.toast.show({ severity: 'error', summary: 'Please fill all the required fields.', detail: "Please fill all the required fields.", life: 3000 });
        }

    }

    onHandleNavigate = (isContinue) => {
        if (isContinue === 'saveAndNext') {
            // Same logic as "Next Step" in index.js
            if (this.state.exam?.exam?.score == undefined && this.state?.score == undefined) {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Please update exam data', detail: 'Please update exam data', life: 3000 });
                return;
            }

            const { registration } = this.state?.admissionSettingsInfo;
            localStorage.setItem('applicationId', this.state.exam?._id);

            if (registration) {
                if (this.props.permissionIds?.includes(PERMISSIONS.CREATE_REGISTRATION)) {
                    this.props.navigate('/addRegistration');
                } else {
                    this.toast.show({ severity: 'error', summary: 'You dont have access to continue.', life: 3000 });
                }
            } else {
                if (this.props.permissionIds?.includes(PERMISSIONS.CREATE_ENROLLMENT)) {
                    this.props.navigate('/confirm-enrollment');
                } else {
                    this.toast.show({ severity: 'error', summary: 'You dont have access to continue.', life: 3000 });
                }
            }
        } else if (isContinue) {
            // Navigate back to exam list
            this.props.navigate('/admission-exam');
        } else {
            // Close dialog
            this.setState({ isEdit: false }, () => this.props.onHandleClose());
        }
    }

    onSubmitExam = async (isContinue) => {
        const { registration, enrollment } = this.state?.admissionSettingsInfo

        // Check if exam fee is required and paid
        if (this.state.isShowPayFeeButton && !this.state.isExamFeePaid) {
            this.toast.show({
                severity: 'error',
                summary: 'Payment Required',
                detail: 'Please pay the exam fee before proceeding to the next step',
                life: 5000
            });
            return;
        }

        const formStatus = isFormValid(createExamFields, this.formFields.formValidations, trimObj(this.state.exam));
        let isCompleteFormValid = true;
        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                formValidations: formStatus.formValidations,
            });
            isCompleteFormValid = false;
        }
        if (!this.state.examType && !this.state.date && !this.state.time && (!this.state.allotExam || !this.state.selectPaper)) {
            isCompleteFormValid = false;
            this.toast.show({ severity: 'error', summary: 'Please Enter all the required Fields', detail: 'Please Enter all the required Fields', life: 3000 });
            return; // Return early without setting isLoading
        }

        // Validate exam date and time are not in the past
        // if (this.state.date && this.state.time) {
        //     const examDate = new Date(this.state.date);
        //     const examTime = new Date(this.state.time);

        //     // Combine date and time
        //     const examDateTime = new Date(
        //         examDate.getFullYear(),
        //         examDate.getMonth(),
        //         examDate.getDate(),
        //         examTime.getHours(),
        //         examTime.getMinutes(),
        //         0,
        //         0
        //     );

        //     const currentDateTime = new Date();

        //     if (examDateTime < currentDateTime) {
        //         this.toast.show({
        //             severity: 'error',
        //             summary: 'Invalid Date/Time',
        //             detail: 'Exam date and time cannot be in the past',
        //             life: 4000
        //         });
        //         return;
        //     }
        // }

        // Only set loading if validation passed
        if (!isCompleteFormValid) {
            return; // Return early if form is not valid
        }

        this.setState({
            isLoading: true
        });
        const academicSession = localStorage.getItem('userAcademicYear')

        let payload = {}
        payload._id = this.state.exam?._id
        payload.examType = this.state.examType
        payload.orgId = this.state.exam?.orgId
        payload.academicSession = academicSession
        payload.applicationId = this.state.exam?.applicationId
        payload.date = this.state.date ? convertUtc(this.state.date) : convertUtc(new Date())
        payload.time = this.state.time ? this.state.time : new Date()
        payload.board = this.state.exam?.board
        payload.grade = this.state.exam?.grade
        payload.score = this.state?.score || null
        payload.remarks = this.state?.remarks || null
        // Only set stage to Exam if student is not already enrolled
        if (this.state.exam?.stage !== "Confirmed") {
            payload.stage = "Exam"
        }
        if (payload.examType === "offline") {
            payload.allotExam = this.state.allotExam?.allotExam
        } else {
            payload.selectPaper = this.state.selectPaper
        }
        const url = `${baseUrlAdmin}/admissions/add-exam`
        this.service.post(url, payload, true).then(res => {
            if (res && res.status && res.res.status) {
                this.setState({
                    isLoading: false,
                    createdId: res?.res?.data,
                    isEdit: false
                }, () => { this.onHandleNavigate(isContinue) });
                this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });

            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
            this.toast.show({ severity: 'error', summary: "Error", detail: 'Some error occured', life: 3000 });
        })
    }

    onCheckFeePaidInfo = async (isContinue) => {
        const url = `${baseUrlAdmin}/admissions/feePaidInfo?_id=${this.state.exam?._id}`
        this.service.get(url, true).then(res => {

            if (res && res.status && res.res.status) {
                const receiptInfo = res?.res?.data;
                const isExamFeePaid = receiptInfo?.isExamFeePaid || false;

                this.setState({
                    isLoading: false,
                    receiptInfo: receiptInfo,
                    isExamFeePaid: isExamFeePaid
                }, () => this.handleShowReceipt(isContinue));
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        })
    }

    handleShowReceipt = (isContinue) => {
        const { receiptInfo } = this.state
        console.log("receiptInfo===============", receiptInfo);

        if (!isContinue) {
            this.setState({
                isExamFeePaid: receiptInfo?.isExamFeePaid || false
            })
        }
        else {
            // Handle two cases:
            // 1. receiptInfo from payment verification (flat structure with receiptNo at root)
            // 2. receiptInfo from feePaidInfo (nested structure with exam.receiptNo)

            const stageData = receiptInfo?.exam || receiptInfo;

            // Extract date - handle both ISO string and MongoDB $date object
            let receiptDate = stageData?.date || receiptInfo?.date;
            if (receiptDate && receiptDate.$date) {
                receiptDate = receiptDate.$date; // Extract from MongoDB format
            }

            let receiptData = {
                receiptName: stageData?.FeeTypeName || receiptInfo?.FeeTypeName || this.state.feePayInfo?.label || 'Exam Fee',
                receiptNo: stageData?.receiptNo || receiptInfo?.receiptNo,
                receiptDate: receiptDate,
                studentName: stageData?.studentName || receiptInfo?.studentName || `${this.state.exam?.firstName || ''} ${this.state.exam?.lastName || ''}`.trim(),
                academicYear: stageData?.academicYearCode || receiptInfo?.academicYearCode || this.state.exam?.academicSession,
                className: stageData?.gradeName || receiptInfo?.gradeName || this.state.exam?.gradeName,
                paymentMode: stageData?.paymentMode || receiptInfo?.paymentMode || 'Online',
                // CRITICAL: Use transactionId (actual payment gateway ID), NOT orderId
                transactionId: stageData?.transactionId || stageData?.transctionId || receiptInfo?.transactionId || this.state.transctionId,

                feePaidDetails: [
                    {
                        feeType: stageData?.FeeTypeName || receiptInfo?.FeeTypeName || this.state.feePayInfo?.feeName || 'Exam Fee',
                        amountPaying: Number(stageData?.feeAmount || receiptInfo?.feeAmount || receiptInfo?.amount || this.state.feePayInfo?.amount || 0),
                        fineAmtPaying: 0,
                        gstPaidNow: 0
                    }
                ],
                amountPaid: Number(stageData?.feeAmount || receiptInfo?.feeAmount || receiptInfo?.amount || this.state.feePayInfo?.amount || 0)
            }

            console.log('📄 Exam Receipt Data:', {
                stageData: stageData,
                transactionId: receiptData.transactionId,
                amountPaid: receiptData.amountPaid,
                orderId: stageData?.orderId,
                source: receiptInfo?.exam ? 'AdmissionFee document (nested)' : 'Payment verification (flat)'
            });

            this.setState({
                isShowReceipt: true,
                receiptInfo: receiptData,
                isExamFeePaid: receiptInfo?.isExamFeePaid || false,
                isPaymentJustCompleted: false // Reset the flag after showing receipt
            })
        }
        if (!this.state.isShowPayFeeButton) {
            this.setState({
                isExamFeePaid: true
            })
        }
    }

    // handleCancel = () => {
    //     if (!this.state.isEdit) {
    //         this.props.navigate('/admission-exam');
    //     } else {
    //         this.setState({ isEdit: false, exam: this.formFields.data }, () => this.props.onHandleClose());
    //     }
    // }

    render() {
        const { exam, formValidations, payFeeFormData, payFormValidations } = this.state;
        return (
            <>
                <div>
                    <div className="grid  md:col-12 lg:rid-col-12 mx-5 column-gap-8 " >
                        {exam?.applicationId && <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Application ID<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    // icon={<MailIcon width={24} height={24} color={"black"} />}
                                    // id="title"
                                    className='  add-vehicle-field-input w-full '
                                    value={exam.applicationId}
                                    onChange={(e) => onTextChange(e.target.value, 'applicationId', this, createExamFields, exam, formValidations, 'exam', 'formValidations')}
                                    placeholder="Application ID"
                                    disabled={true} />
                            </div>
                            {formValidations && !formValidations.fields['applicationId'].isValid && <p className="p-error text-lg">{formValidations.fields['applicationId'].errorMsg}</p>}

                        </div>}
                        {/* <div className="col-span-1">
                            <p className='transport-fee-form-label'>Academic Session<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    icon={<MailIcon />}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={exam.academicSession}
                                    options={this.state.academicSession}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'academicSession', this, createExamFields, exam, formValidations, 'exam', 'formValidations') }}
                                    placeholder='Select Academic Session'
                                    disabled={true}
                                />
                            </div>
                            {formValidations && !formValidations.fields['academicSession'].isValid && <p className="p-error text-lg">{formValidations.fields['academicSession'].errorMsg}</p>}

                        </div> */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Admission Category<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    // icon={<MailIcon />}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={exam.academicCategory}
                                    options={this.state.academicCategory}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'academicCategory', this, createExamFields, exam, formValidations, 'exam', 'formValidations') }}
                                    placeholder='Admission Category'
                                    disabled={true}
                                />
                            </div>
                            {formValidations && !formValidations.fields['academicCategory'].isValid && <p className="p-error text-lg">{formValidations.fields['academicCategory'].errorMsg}</p>}

                        </div>
                    </div>
                    <div className="grid mt-2 md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student First Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    // icon={<MailIcon width={24} height={24} color={"black"} />}
                                    // id="title"
                                    className='  add-vehicle-field-input w-full '
                                    value={exam.firstName}
                                    width={250}
                                    onChange={(e) => onTextChange(e.target.value, 'firstName', this, createExamFields, exam, formValidations, 'exam', 'formValidations')}
                                    placeholder="Student First Name"
                                    disabled={true}
                                />
                            </div>
                            {formValidations && !formValidations.fields['firstName'].isValid && <p className="p-error text-lg">{formValidations.fields['firstName'].errorMsg}</p>}

                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student Last Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    // icon={<MailIcon width={24} height={24} color={"black"} />}
                                    // id="title"
                                    className='  add-vehicle-field-input w-full '
                                    width={250}
                                    value={exam.lastName}
                                    onChange={(e) => onTextChange(e.target.value, 'lastName', this, createExamFields, exam, formValidations, 'exam', 'formValidations')}
                                    placeholder="Student Last Name" disabled={true} />
                            </div>
                            {formValidations && !formValidations.fields['lastName'].isValid && <p className="p-error text-lg">{formValidations.fields['lastName'].errorMsg}</p>}
                        </div>

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Contact no<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    // icon={<MailIcon width={24} height={24} color={"black"} />}
                                    className='  add-vehicle-field-input w-full '
                                    value={exam.contactNo}
                                    width={250}
                                    keyfilter='int'
                                    onChange={(e) => onTextChange(e.target.value, 'contactNo', this, createExamFields, exam, formValidations, 'exam', 'formValidations')}
                                    placeholder="Contact no" disabled={true} />
                            </div>
                            {formValidations && !formValidations.fields['contactNo'].isValid && <p className="p-error text-lg">{formValidations.fields['contactNo'].errorMsg}</p>}

                        </div>

                        <div className="col-span-1  ">
                            <p className='transport-fee-form-label'>Email ID<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    // icon={<MailIcon width={24} height={24} color={"black"} />}
                                    className='  add-vehicle-field-input w-full '
                                    value={exam.emailId}
                                    onChange={(e) => onTextChange(e.target.value, 'emailId', this, createExamFields, exam, formValidations, 'exam', 'formValidations')}
                                    width={250}
                                    placeholder="Email ID" disabled={true} />
                            </div>
                            {formValidations && !formValidations.fields['emailId'].isValid && <p className="p-error text-lg">{formValidations.fields['emailId'].errorMsg}</p>}

                        </div>
                    </div>
                    <div className='flex justify-content-between mx-5 mt-2 '>

                        <div className='flex align-items-center' >
                            {selectedExamType.map((tab, index) => (
                                <div key={index} >
                                    <p className='px-3 py-3 inter500semibold' style={{ margin: 0, }}>{tab.label}
                                        <RadioButton inputId="examType"
                                            name="examType"
                                            id='examType'
                                            value={tab.value}
                                            style={{ marginLeft: "150px", marginRight: "80px" }}
                                            onChange={(e) => this.setState({ examType: e.value })} checked={this.state.examType === tab.value}
                                        />
                                    </p>
                                </div>
                            ))}
                        </div>


                    </div>

                    {this.state.examType === "offline" &&
                        <div className="grid mt-2 md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >

                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Exam Date<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetCalendar
                                        width={250}
                                        // icon={<CalenderCheckIcon width={24} height={24} color={"black"} />}
                                        className=' border-round-md add-vehicle-field-input text-xl w-full'
                                        calendarMode={'single'}
                                        value={this.state.date ? new Date(this.state.date) : new Date()}
                                        onChange={(e) => { this.setState({ date: e.value }) }}
                                        placeholder="DD/MM/YYYY" />
                                </div>
                            </div>

                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Exam Time<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetCalendar
                                        width={250}
                                        // icon={<ClockIcon height={20} />}
                                        className=""
                                        calendarMode="single"
                                        value={this.state.time ? new Date(this.state.time) : new Date()}
                                        onChange={(e) => this.setState({ time: e.target.value })}
                                        timeOnly
                                        placeholder="HH:MM"
                                    />
                                </div>

                            </div>

                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Allot Question Paper<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <FileUpload
                                        id={"allotExam"}
                                        //multiple={false}
                                        onProgress={this._onProgress}
                                        onSucess={this._onUploadPdf}
                                        // Reset={this.state.Reset}
                                        //maxFileSize={307200}
                                        //onError={this._onFilsUploadError}
                                        maxFileSize={StaticConstants.MAX_FILE_SIZE}
                                        onError={this._onFilsUploadError}
                                        accept={'pdfs'}
                                        title={'Pdfs and Docs'}
                                        afterFilesUploaded={this._afterFilesUploaded} >
                                        <span className="button-style">Upload</span>

                                    </FileUpload>

                                    {(this.state.allotExam?.allotExam || true) && (
                                        <div className="uploaded-file-name " style={{ marginTop: "-1px" }}>
                                            Uploaded File: {this.state?.uploadedFileName || this.state.allotExam?.fileName}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {this.props.editExam?._id &&
                                <div className='flex flex-row column-gap-8'>
                                    <div className="col-span-1 ">
                                        <p className='transport-fee-form-label'>Score<span className='ma-required'>*</span></p>
                                        <div className='flex'>
                                            <ClassetInputText
                                                // icon={<BrowseIcon width={24} height={24} color={"black"} />}
                                                className='  add-vehicle-field-input w-full '
                                                value={this.state.score}
                                                width={250}
                                                keyfilter="int"
                                                onChange={(e) => this.setState({ score: e.target.value })}
                                                placeholder="Enter Score" />
                                        </div>
                                    </div>


                                    <div className="col-span-1 ">
                                        <p className='transport-fee-form-label'>Remarks</p>
                                        <div className="flex">
                                            <ClassetTextArea
                                                placeholder='Enter Remarks'
                                                className=""
                                                width={550}
                                                value={this.state.remarks}
                                                onChange={(e) => this.setState({ remarks: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                </div>

                            }
                        </div>

                    }
                    {this.state.examType === "online" &&
                        <div className="grid mt-2 md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >

                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Exam Date<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetCalendar
                                        width={250}
                                        // icon={<CalenderCheckIcon width={24} height={24} color={"black"} />}
                                        className=' border-round-md add-vehicle-field-input text-xl w-full'
                                        calendarMode={'single'}
                                        value={this.state.date ? new Date(this.state.date) : new Date()}
                                        onChange={(e) => { this.setState({ date: e.value }) }}
                                        placeholder="DD/MM/YYYY" />
                                </div>
                            </div>

                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Exam Time<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetCalendar
                                        width={250}
                                        // icon={<ClockIcon height={20} />}
                                        className=""
                                        calendarMode="single"
                                        value={this.state.time ? new Date(this.state.time) : new Date()}
                                        onChange={(e) => this.setState({ time: e.target.value })}
                                        timeOnly
                                        placeholder="HH:MM"
                                    />
                                </div>
                            </div>

                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Select Paper<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        // icon={<BrowseIcon width={24} height={24} color={"black"} />}
                                        className='  add-vehicle-field-input w-full '
                                        value={this.state.selectPaper}
                                        width={250}
                                        onChange={(e) => this.setState({ selectPaper: e.target.value })}
                                        placeholder="Select Paper" />
                                </div>


                            </div>
                        </div>

                    }

                    <div className="text-center mt-8 flex justify-content-center mr-5 mb-5 ">
                        {/* <Button icon={'pi pi-plus-circle text-lg '} label='Save and Proceed to Next Step' onClick={this.onSubmitApplication} className='confirmDialogAcceptBtn  mr-5 w-24rem ' /> */}
                        {this.state.isShowPayFeeButton && <div >
                            <Button className='add-vehicle-btn mr-4 flex align-items-center justify-content-center' style={{ padding: "20px" }} disabled={this.state.isExamFeePaid ? true : false} onClick={() => this.openDailogPayAppFee()}>
                                Pay Fee
                            </Button>
                        </div>}
                        <Button
                            icon={' text-lg '}
                            label={!this.state.isEdit ? 'Save' : 'Save'}
                            onClick={() => !this.state.isEdit ? this.onSubmitExam(true) : this.onSubmitExam(false)}
                            className='confirmDialogAcceptBtn  mr-5 w-9rem p-5'
                            disabled={this.state.isShowPayFeeButton && !this.state.isExamFeePaid}
                            tooltip={this.state.isShowPayFeeButton && !this.state.isExamFeePaid ? "Please complete exam fee payment to save" : ""}
                            tooltipOptions={{ position: 'top' }}
                        />
                        {/* <Button
                            icon={' text-lg '}
                            label='Save and Next'
                            onClick={() => this.onSubmitExam('saveAndNext')}
                            className='confirmDialogAcceptBtn  mr-5 w-18rem p-5'
                            disabled={this.state.isShowPayFeeButton && !this.state.isExamFeePaid}
                            tooltip={this.state.isShowPayFeeButton && !this.state.isExamFeePaid ? "Please complete exam fee payment to proceed" : ""}
                            tooltipOptions={{ position: 'top' }}
                        /> */}
                        <Button label='Cancel'
                            style={{
                                background: '#E6E8EA', border: '0px', borderRadius: '12px', maxHeight: '48px', width: '120px', font: "InterSemiBold !important",
                                fontSize: '16px', color: 'black'
                            }}
                            className='confirmDialogCancelBtn p-5' onClick={() => !this.state.isEdit ? this.props.navigate('/admission-exam') : this.setState({ isEdit: false, exam: this.formFields.data }, () => this.props.onHandleClose())}
                        />

                    </div>
                </div>

                <Dialog
                    isopen={this.state.isOpenPayFeeDailog}
                    visible={this.state.isOpenPayFeeDailog}
                    className="pay-fee"
                    style={{ position: 'fixed', right: '0' }}
                    draggable={false}
                    onHide={this.onHandleCancelPayFee}
                    closable={false}
                    header={() => {
                        return (<div className='mt-2 mb-4'>
                            <h3 className="formhead text-center ">Pay Fee</h3>

                        </div>)
                    }}
                >
                    <div className="mb-5 ml-5 mr-5">
                        <div>
                            <div className="col-12">
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='term'
                                        className=""
                                        height="48px"
                                        width="368px"
                                        placeholder="Fee Type name"
                                        value={`${this.state.feePayInfo?.feeName || ""}`}
                                        disabled={true}
                                        onChange={(e) => onTextChange(e.target.value, 'FeeTypeName', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}
                                    />
                                </div>
                                {payFormValidations && !payFormValidations.fields['FeeTypeName'].isValid && <p className="p-error">{payFormValidations.fields['FeeTypeName'].errorMsg}</p>}
                            </div>

                            <div className="col-12">
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='feeAmount'
                                        className=""
                                        height="48px"
                                        width="368px"
                                        placeholder="Fee Amount"
                                        disabled={true}
                                        value={`${Number(this.state.feePayInfo?.amount) || 0}`}
                                        onChange={(e) => onTextChange(e.target.value, 'feeAmount', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}

                                    />
                                </div>
                                {payFormValidations && !payFormValidations.fields['feeAmount'].isValid && <p className="p-error">{payFormValidations.fields['feeAmount'].errorMsg}</p>}
                            </div>
                            <div className="col-12">
                                <div className="mt-2">
                                    <ClassetDropdown
                                        id='paymentType'
                                        className=""
                                        height="48px"
                                        width="368px"
                                        options={this.state.paymentModes}
                                        value={payFeeFormData.paymentType}
                                        onChange={(e) => { onDropDownChange(e.target.value, 'paymentType', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations) }}
                                        placeholder={(
                                            <div>
                                                <span className=''>Payment Type</span>
                                            </div>
                                        )}
                                    />
                                </div>
                                {payFormValidations && !payFormValidations.fields['paymentType'].isValid && <p className="p-error">{payFormValidations.fields['paymentType'].errorMsg}</p>}
                            </div>
                            {(
                                // payFeeFormData.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' || 
                                payFeeFormData.paymentType === 'b9e46415-1b11-4377-9105-58b98c230935' ||
                                payFeeFormData.paymentType === '274a4416-2454-4f3a-b741-89c67361ae1f'
                                // payFeeFormData.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489'
                            ) &&
                                <div className="col-12">
                                    <label className='label mb-2 '>Transaction Id<span className='ma-required'>*</span></label>
                                    <div className="mt-2">
                                        <ClassetInputText
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Enter Transaction Id"
                                            value={this.state.transctionId}
                                            onChange={(e) => this.setState({ transctionId: e.target.value })}

                                        />
                                    </div>

                                </div>
                            }
                            {payFeeFormData.paymentType &&
                                <div className="col-12">
                                    <label className='label mb-2 '>Remarks<span className='ma-required'></span></label>
                                    <div className="mt-2">
                                        <ClassetTextArea
                                            id='feeType'
                                            className=""
                                            height="48px"
                                            width="368px"
                                            placeholder="Enter Remarks"
                                            value={payFeeFormData.remarks}
                                            onChange={(e) => onTextChange(e.target.value, 'remarks', this, createFields, payFeeFormData, payFormValidations, 'payFeeFormData', payFormValidations)}

                                        />
                                    </div>

                                </div>
                            }
                            <div className='flex justify-content-center mb-4 mt-4'>

                                <Button className='formSubmitButtonn mr-2' style={{ borderRadius: '12px', fontSize: '16px', backgroundColor: '#076EFF' }}
                                    // onClick={this.OnPayFee}
                                    onClick={this.handlePayment}
                                >
                                    <AddIcon2 />
                                    <p className='formSubmitButtonnText'>Pay Now</p>
                                </Button>
                                <Button className='cancelButtonn w-4'
                                    onClick={this.onHandleCancelPayFee} >

                                    <p className='cancelButtonnText'>Cancel</p>
                                </Button>
                            </div>
                        </div>
                    </div>


                </Dialog>
                {
                    this.state.isShowReceipt && <FeeReciept receiptData={this.state?.receiptInfo} hideFeeReciept={() => {
                        this.setState({
                            isShowReceipt: false,
                            receiptInfo: {}
                        })

                    }} />
                }
                {/* {this.state.showNTTPayment && this.state.nttPaymentData && ( */}
                <NTTPaymentComponent
                    key={this.state.paymentTimestamp || 'ntt-payment'}
                    showPaymentButton={this.state.showNTTPayment}
                    paymentData={this.state.nttPaymentData}
                    onPaymentSuccess={this.onNTTPaymentSuccess}
                    onPaymentError={this.onNTTPaymentError}
                    onPaymentCancel={this.onNTTPaymentCancel}
                />
                {/* )} */}
                {
                    this.state.isLoading && <>
                        <LoadingComponent />
                    </>
                }
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </>

        )
    }
}
const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
});
export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(Authentication(withRouter(ExamCreate)));